import React from "react"
import CircularProgress from "material-ui/CircularProgress"
import JobDetailsSummary from "./JobDetailsSummary"
import JobDetailsData from "./JobDetailsData"
import autobind from "class-autobind"
import { IJobDocument, IJobStatus } from "../../../models"
import * as api from "../../../api"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import JobDashboard from "./job_dashboard/JobDashboard"
import strings from "../../../localization/strings"
interface IProps {
    params: { jobId: string }
}
interface IState {
    job: IJobDocument
    showProgress: boolean
    jobStatuses: IJobStatus[]
}

export default class JobDetails extends React.Component<IProps, IState> {
    constructor(props, context) {
        super(props, context)
        this.state = {
            job: null,
            showProgress: true,
            jobStatuses: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getJob()
        this.getJobStatuses()
    }

    getJob() {
        api.getJob(this.props.params.jobId).then(res =>
            this.setState({
                showProgress: false,
                job: res.data
            }, () => {
                document.title = this.state.job.ExternalId ? `${strings.Job} #${this.state.job.ExternalId} | ${strings.Findd_Grandd_Central}` : `${strings.Job} - ${this.state.job.Name} | ${strings.Findd_Grandd_Central}`
            })
        )
    }

    reloadJob(): Promise<IJobDocument> {
        return new Promise(resolve => {
            api.getJob(this.props.params.jobId).then(res =>
                this.setState({ showProgress: false, job: res.data },() => resolve(this.state.job))
            )
        })
    }

    getJobStatuses() {
        AccountStore.getHREnabled() &&
            api.getJobStatuses(AccountStore.getCurrentAccount().Id).then(res => {
                const result = res.data as IJobStatus[]
                this.setState({ jobStatuses: result.filter(i => i.Active) })
            })
    }

    handleUpdateJob(job: IJobDocument) {
        return api.updateJob(job).then(res =>
            this.setState({ job: res.data })
        )
    }

    handlePatchJob(job: IJobDocument) {
        api.patchJob(this.state.job.Id, job).then(res => this.setState({ job: res.data }))
    }

    render() {
        return (
            <div className="page-container">
                {this.state.showProgress ?
                    <div className="spinner" style={{ display: "flex", flex: "1 1 100%", placeContent: "center", height: "75vh", paddingTop: "12em" }}>
                        <CircularProgress />
                    </div> :
                    <div className="user-details">
                        <JobDashboard
                            job={this.state.job}
                        />
                        <JobDetailsSummary
                            readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.EditJobs)}
                            job={this.state.job}
                            jobStatuses={this.state.jobStatuses}
                            handleUpdateJob={this.handleUpdateJob}
                            reloadJob={this.getJob}
                        />
                        <JobDetailsData
                            readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Jobs.EditJobs)}
                            job={this.state.job}
                            handleUpdateJob={this.handleUpdateJob}
                            reloadJob={this.getJob}
                            reloadJobWithPromise={this.reloadJob}
                        />
                    </div>
                }
            </div>
        )
    }
}
